import { render, staticRenderFns } from "./TaskCollect.vue?vue&type=template&id=190225ff&"
import script from "./TaskCollect.vue?vue&type=script&lang=js&"
export * from "./TaskCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports